import { EnumBase } from 'hay-core-react';
class HomologacaoIntegracaoObrigatoriedadeCredencialEnum extends EnumBase {
    constructor() {
        super(
            [
                'main.homologacaointegracao.obrigatoriedadecredencial.desativado',
                'main.homologacaointegracao.obrigatoriedadecredencial.opcional',
                'main.homologacaointegracao.obrigatoriedadecredencial.obrigatorio',
            ],
            'main.homologacaointegracao.obrigatoriedadecredencial.obrigatorio'
        );
    }
}

const instance = new HomologacaoIntegracaoObrigatoriedadeCredencialEnum();
export default instance;
